<template>
  <RouterLink
    v-if="isAnchor"
    :to="routerLinkTo"
    v-bind="newTabOptions"
    @click.stop="handleAnchorClick"
  >
    <slot v-if="$slots.default" />
    <span v-else>{{ path }}</span>
  </RouterLink>
  <Component
    :is="tag"
    v-else
    @click.stop.prevent="handleNonAnchorClick"
  >
    <slot v-if="$slots.default" />
    <span v-else>{{ path }}</span>
  </Component>
</template>

<script lang="ts">
import { PropType, defineComponent } from 'vue';
import { mapWaitingActions } from 'vue-wait';

// FIXME: 利用先が自由気ままなのでここもある程度自由度を残しています。最終的に a or something で自動的にrenderされ、固定されるのが美しいと思います
// component構造が見直されたら修正してください
type TTag = 'a' | 'div' | 'span'

export default defineComponent({
  props: {
    callTargetId: {
      type: Number,
      required: true,
    },
    additionalQueryParams: {
      type: Object as PropType<Record<string, unknown>>,
      required: false,
    },
    tag: {
      type: String as PropType<TTag>,
      required: false,
      default: 'a',
    },
    inNewTab: {
      type: Boolean,
      required: false,
      default: false,
    },
    openByLeadList: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  emits: [
    'beforeMove',
  ],
  computed: {
    isAnchor(): boolean {
      return this.tag === 'a';
    },
    isLeadPage(): boolean {
      return this.$route.name === 'LeadList';
    },
    routerLinkTo() {
      return {
        name: 'LeadList',
        query: this.leadListQueryParams,
      };
    },
    newTabOptions() {
      if (!this.inNewTab) return {};
      return {
        target: '_blank',
        rel: 'noopener noreferrer',
      };
    },
    path(): string {
      return this.$router.resolve(this.routerLinkTo).href;
    },
    queryParams(): { callTargetId: number; [key: string]: unknown } {
      return {
        ...this.additionalQueryParams ?? {},
        callTargetId: this.callTargetId,
      };
    },
    leadListQueryParams(): { callTargetId: number; [key: string]: unknown } {
      if (this.isLeadPage) {
        return {
          ...this.$route.query,
          ...this.queryParams,
        };
      }
      return { ...this.queryParams };
    },
  },
  methods: {
    ...mapWaitingActions('userUi', {
      setIsLeadOpenByLeadListAction: 'setIsLeadOpenByLeadListActionWait',
    }),
    // NOTE: preventDefaultしないこと。cmd/ctrl+クリック・中クリック・target="_blank"の判定は
    // vue-routerのguardEventがブラウザに委ねてくれるので、独自の修飾キー判定を書いてはいけない。
    // 遷移自体はRouterLinkが行い、ここでは「どこから開かれたか」の記録だけを行う。
    handleAnchorClick(): void {
      this.recordMoveIntent();
    },
    handleNonAnchorClick(): void {
      this.recordMoveIntent();
      // NOTE: tagがdiv/spanのときはhrefを持たないため、JSで遷移させる
      if (this.inNewTab) {
        window.open(this.path, '_blank');
        return;
      }
      this.$router.push(this.routerLinkTo);
    },
    recordMoveIntent(): void {
      this.$emit('beforeMove');
      this.setIsLeadOpenByLeadListAction(this.openByLeadList);
    },
  },
});
</script>
